export interface StatItem {
  value: string;
  label: string;
  icon: string;
}

export interface StepItem {
  step: string;
  title: string;
  desc: string;
  icon: string;
}

export interface TestimonialItem {
  name: string;
  role: string;
  quote: string;
}

export interface PrincipleItem {
  title: string;
  desc: string;
  icon: string;
}

export const siteInfo = {
  name: '瓜田求证社',
  slogan: '理性吃瓜，求证先行',
  intro:
    '我们是一群对"到底是怎么回事"有执念的人，把零散的网传说法整理成结构化的求证档案：传闻原文、来源出处、时间线、佐证与反证，以及一个尽可能诚实的结论。',
  email: 'hello@guatian-qiuzheng.cn',
  workingTime: '每周一至周五 10:00 - 18:00',
};

export const stats: StatItem[] = [
  { value: '1,284', label: '累计求证话题', icon: 'ri-file-list-3-line' },
  { value: '7,930', label: '核对信源条目', icon: 'ri-links-line' },
  { value: '412', label: '已辟谣档案', icon: 'ri-shield-check-line' },
  { value: '96.2%', label: '结论可追溯率', icon: 'ri-history-line' },
];

export const steps: StepItem[] = [
  {
    step: '01',
    title: '记录传闻原文',
    desc: '完整保存爆料内容与首发时间，不删改、不带情绪，先弄清楚"到底在说什么"。',
    icon: 'ri-quill-pen-line',
  },
  {
    step: '02',
    title: '拆解可验证点',
    desc: '把一段模糊的描述切成若干可以证实或证伪的事实点，避免被整体印象带着走。',
    icon: 'ri-scissors-cut-line',
  },
  {
    step: '03',
    title: '多源交叉比对',
    desc: '分别查找一手信源、机构口径与独立旁证，确认它们是否真的相互独立。',
    icon: 'ri-node-tree',
  },
  {
    step: '04',
    title: '给出分级结论',
    desc: '按证据强度给出已求证、已辟谣、求证中或存疑，并在有更新时公开修订。',
    icon: 'ri-award-line',
  },
];

export const principles: PrincipleItem[] = [
  {
    title: '先证据，后情绪',
    desc: '结论只跟随材料走，不因为话题热度或立场偏好而改变判断尺度。',
    icon: 'ri-scales-3-line',
  },
  {
    title: '标注不确定',
    desc: '材料不足就写材料不足，宁可承认不知道，也不给出看起来确定的错误答案。',
    icon: 'ri-error-warning-line',
  },
  {
    title: '可追溯与可修订',
    desc: '每个结论都附来源与时间线；发现新证据时，在原页面更新并保留修改说明。',
    icon: 'ri-git-branch-line',
  },
];

export const testimonials: TestimonialItem[] = [
  {
    name: '林可',
    role: '内容创作者',
    quote: '以前看到爆料第一反应是转发，现在会先来这里搜一下。时间线和证据清单帮我把节奏放慢了。',
  },
  {
    name: '周叙',
    role: '高校教师',
    quote: '把它当成信息素养的案例库挺好用的，尤其是"旧闻新炒"那一类，讲给学生听很有说服力。',
  },
  {
    name: '徐一诺',
    role: '品牌公关',
    quote: '被卷进过一次传言，才发现有个把材料摆清楚的地方有多重要。至少讨论有据可依了。',
  },
];